import * as React from 'react';
import cn from '~modules/cn';
import Style from './status.module.scss';

export type StatusProps = {
    type: 'active' | 'primary' | 'disabled' | 'staled';
    text: string;
    className?: string;
};

export default function Status(props: StatusProps) {
    return <span className={cn(Style.status, Style[`status-${props.type}`], props.className)}>{props.text}</span>;
}
